import { render, staticRenderFns } from "./PasswordRecoveryView.vue?vue&type=template&id=6cda7872&"
import script from "./PasswordRecoveryView.vue?vue&type=script&lang=ts&"
export * from "./PasswordRecoveryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports